/**
 * 基础配置 - 操作日志 接口定义
 */
import { apiGet } from '@/utils/request';

/** 操作日志列表查询参数 */
export interface OperationLogQueryParams {
  /** 操作类型 新增 修改 删除 */
  action?: string;
  /** 应用 ID */
  app_id?: number;
  /** 结束日期（Y-m-d，且不小于 start_date） */
  end_date?: string;
  /** 操作模块（模糊匹配） */
  module?: string;
  /** 页码，默认 1 */
  page?: number;
  /** 每页条数，默认 20，最大 100 */
  page_size?: number;
  /** 请求方法（如 GET/POST） */
  request_method?: string;
  /** 开始日期（Y-m-d） */
  start_date?: string;
  /** 操作人 ID */
  user_id?: number;
  /** 操作人名称（模糊匹配） */
  user_name?: string;
}

/** 操作日志列表响应 */
export interface OperationLogListResponse {
  list: OperationLogItem[];
  total: number;
  page: number;
  page_size: number;
}

/** 操作日志项 */
export interface OperationLogItem {
  id?: number;
  /** 操作内容 */
  content?: string;
  /** 操作类型 */
  action?: string;
  /** 模块 */
  module?: string;
  /** 用户id */
  user_id?: number;
  /** appid */
  app_id?: number;
  user_type?: string;
  /** 用户名称 */
  user_name?: string;
  /** 用户权限 */
  user_role?: string;
  /** ip */
  request_ip?: string;
  request_url?: string;
  request_method?: string;
  created_at?: string;
}

/**
 * 分页查询操作日志列表
 */
export function queryOperationLogList(
  params: OperationLogQueryParams,
): Promise<OperationLogListResponse> {
  return apiGet<OperationLogListResponse>('/operation-logs', params as Record<string, unknown>);
}
